let currentScroll = 0;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

window.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".Header"))
    document.documentElement.style.setProperty(
      "--header-height",
      document.querySelector(".Header").offsetHeight + "px"
    );
  window.addEventListener("resize", resize);
  window.addEventListener("scroll", scrolling);
  window.addEventListener("keyup", keyPress);
  document.addEventListener("click", clickAnywhere);
  htmlTopOrNot();
  stickyFiltersOrNot();
  initEmptyCartSwiper();
  // blackOrWhiteObserver()
});

function achatDirect(e, variantId) {
  e.preventDefault();

  const data = {
    id: variantId,
    quantity: 1,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      updateCart();
      document.querySelector(".oCart").dataset.active = true;
      document.body.classList.add("overflow-hidden");
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

function addToCart(e) {
  e.preventDefault();
  e.target.querySelector('[type="submit"]').disabled = true;

  document.querySelector(".oCart").dataset.active = true;
  document.body.classList.add("overflow-hidden");

  let formData = Object.fromEntries(new FormData(e.target));

  // Gestion dynamique des propriétés (properties[])
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key]; // On enlève la propriété brute du formData
    }
  }

  // Ajout des propriétés dynamiques dans formData
  if (Object.keys(properties).length > 0) formData.properties = properties;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      // console.log(JSON.stringify(Object.fromEntries(new FormData(e.target))))
      updateCart();
      e.target.querySelector('[type="submit"]').disabled = false;
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

window.cartUpdateQuantity = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".oCart_item").dataset.id;
  const quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value
  );
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartReduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".oCart_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("[name='quantity']").value) - 1;
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;
  currentValue--;
  if (currentValue == 1)
    e.parentNode.querySelector("input").classList.add("off");
  e.parentNode.querySelector("input").value = currentValue;
}

window.cartIncreaseQty = (el) => {
  const maxStock = parseInt(el.getAttribute("max"));
  if (maxStock <= 0) return;

  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".oCart_item").dataset.id;
  let quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value
  );
  quantity++;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        if (document.querySelector(".product_errors")) {
          el.parentNode.parentNode.parentNode
            .querySelector(".product_errors")
            .classList.remove("hidden");
          el.parentNode.parentNode.parentNode.querySelector(
            ".product_errors_message"
          ).textContent = erreurs;
        }
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

function fetchCartUpdateQty(el, itemId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".oCart_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));
}

function updateCart() {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(window.location.href)
    .then((response) => {
      if (!response.ok)
        throw new Error("Pas de réponse réseau " + response.statusText);
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
        initEmptyCartSwiper();
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  // updateCartLink()
}

/*
function updateCartLink() {
  fetch('/cart/update')
    .then(response => response.text())
    .then(data => {
      let parser = new DOMParser()
      let doc = parser.parseFromString(data, 'text/html')
      
      let newCartContent = doc.querySelector('.open-cart-link').innerHTML
      document.querySelector('.open-cart-link').innerHTML = newCartContent
    })
    .catch(error => console.error('Erreur lors de la mise à jour du panier :', error))
}
*/

function removeQty(e) {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = e.target.closest(".oCart_item").dataset.id;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=0`,
  })
    .then((response) => {
      if (response.ok) {
        updateCart();
        e.target.closest(".oCart_item").remove();
      } else {
        console.error("Impossible de vider le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
}

function initEmptyCartSwiper() {
  if (document.querySelector(".oCart_empty")) {
    const cartProducts = new Swiper(".oCart_empty .swiper", {
      slidesPerView: 2,
      spaceBetween: 4,
      navigation: {
        nextEl: ".oCart_next",
        prevEl: ".oCart_prev",
      },
    });
  }
}

function clickAnywhere(e) {
  if (e.target.classList.contains("open-pop-link")) return;

  if (document.querySelector('.product-card_quickshop[data-active="true"]')) {
    if (
      !document
        .querySelector('.product-card_quickshop[data-active="true"] > *')
        .contains(e.target)
    ) {
      closeQuickshop();
    }
  }
  if (
    window.innerWidth >= 768 &&
    document.querySelector('.oCart[data-active="true"]')
  ) {
    if (e.clientX < window.innerWidth - 490) {
      document.querySelector(".oCart").dataset.active = false;
      document.body.classList.remove("overflow-hidden");
    }
  }
  if (document.querySelector('.Filters[data-active="true"]')) {
    if (
      !document
        .querySelector('.Filters[data-active="true"] > *')
        .contains(e.target)
    ) {
      document.querySelector(".Filters").dataset.active = false;
    }
  }
  if (document.querySelector('#popup_newsletter[data-active="true"]')) {
    if (
      !document
        .querySelector('#popup_newsletter[data-active="true"] > *')
        .contains(e.target)
    ) {
      document.querySelector("#popup_newsletter").dataset.active = false;
    }
  }
  if (document.querySelector('.product_details[data-active="true"]')) {
    if (
      !document
        .querySelector('.product_details[data-active="true"] > *')
        .contains(e.target)
    ) {
      document.querySelector(".product_details").dataset.active = false;
    }
  }
}

function keyPress(e) {
  if (e.code == "Escape") {
    if (document.querySelector('.product-card_quickshop[data-active="true"]'))
      closeQuickshop();
    if (document.querySelector('.oCart[data-active="true"]'))
      document.querySelector(".oCart").dataset.active = false;
    if (document.querySelector('.Filters[data-active="true"]'))
      document.querySelector(".Filters").dataset.active = false;
    if (document.querySelector('#popup_newsletter[data-active="true"]'))
      document.querySelector("#popup_newsletter").dataset.active = false;
    if (document.querySelector('.product_details[data-active="true"]'))
      document.querySelector(".product_details").dataset.active = false;
    document.body.classList.remove("overflow-hidden");
  }
}

function resize() {
  document.documentElement.style.setProperty(
    "--header-height",
    document.querySelector(".Header").offsetHeight + "px"
  );
}

function htmlTopOrNot() {
  if (window.scrollY > 0) {
    if (document.querySelector("html:not(.scrolled)"))
      document.documentElement.classList.add("scrolled");
  } else {
    if (document.querySelector("html.scrolled"))
      document.documentElement.classList.remove("scrolled");
  }
}

function stickyFiltersOrNot() {
  if (!document.querySelector(".Filters")) return;
  else {
    if (document.querySelector(".Filters").getBoundingClientRect().top <= 65) {
      if (document.querySelector("html:not(.stickyFilters)"))
        document.documentElement.classList.add("stickyFilters");
    } else {
      if (document.querySelector("html.stickyFilters"))
        document.documentElement.classList.remove("stickyFilters");
    }
  }
}

function scrolling() {
  /*
  if(window.scrollY>=currentScroll) document.querySelector('.Header').classList.add('above')
  else if(document.querySelector('.Header.above')) document.querySelector('.Header.above').classList.remove('above')
  */
  htmlTopOrNot();
  stickyFiltersOrNot();
  if (document.querySelector("html.nav"))
    document.documentElement.classList.remove("nav");
  if (document.querySelector(".HeroFullMedia")) {
    if (
      document.querySelector(".HeroFullMedia").getBoundingClientRect().bottom >
      window.innerHeight / 2
    )
      document.querySelector(".Header").classList.add("ghost");
    else {
      if (document.querySelector(".Header.ghost"))
        document.querySelector(".Header").classList.remove("ghost");
    }
  }
  currentScroll = window.scrollY;
}

function blackOrWhiteObserver() {
  if (!document.querySelector(".white-nav")) return;
  // document.querySelector('html.white-nav')
  document.querySelectorAll("#MainContent > section").forEach((el) => {
    if (
      el.getBoundingClientRect().top < 100 &&
      el.getBoundingClientRect().bottom > 0
    ) {
      if (el.classList.contains("white-nav")) {
        if (!document.querySelector("html.white-nav"))
          document.documentElement.classList.add("white-nav");
      } else {
        if (document.querySelector("html.white-nav"))
          document.documentElement.classList.remove("white-nav");
      }
    }
  });
  /*
  const observer = new IntersectionObserver(function (entries) {
    entries.map((entry) => {
      if(entry.isIntersecting) {
        if(!document.querySelector('html.white-nav')) document.documentElement.classList.add('white-nav')
      } else {
        if(document.querySelector('html.white-nav')) document.documentElement.classList.remove('white-nav')
      }
    })
  }, {
    rootMargin: "0px 0px 0px 0px"
  })
  for (const item of document.querySelectorAll('#MainContent > section')) {
    observer.observe(item)
  }
  */
}

function openQuickshop(quickshop) {
  console.log("openQuickshop");
  quickshop.parentNode.parentNode.querySelector(
    ".product-card_quickshop"
  ).dataset.active = true;
  document.documentElement.classList.add("pauseSwiper");
}

function openQuickshopWithSize(quickshop, sizeId) {
  quickshop.parentNode.parentNode.parentNode.querySelector(
    ".product-card_quickshop"
  ).dataset.active = true;
  const selectElement =
    quickshop.parentNode.parentNode.parentNode.querySelector(
      ".product-card_quickshop select"
    );
  for (var i = 0; i < selectElement.options.length; i++) {
    if (selectElement.options[i].value == sizeId) {
      selectElement.selectedIndex = i;
      var event = new Event("change");
      selectElement.dispatchEvent(event);
      break;
    }
  }
  quickshop.parentNode.parentNode.parentNode.querySelector(
    ".product-card_quickshop select"
  ).dataset.active = true;
  document.documentElement.classList.add("pauseSwiper");
}

function closeQuickshop() {
  if (document.querySelector('.product-card_quickshop[data-active="true"]'))
    document.querySelector(
      '.product-card_quickshop[data-active="true"]'
    ).dataset.active = false;
  document.documentElement.classList.remove("pauseSwiper");
}

function scrollObserver() {
  Observer.create({
    target: window,
    type: "wheel,scroll",
    onUp: () => monogramDisplay("up"),
    onDown: () => monogramDisplay("down"),
  });
}

function goTo(id) {
  window.scrollTo({
    top: document.querySelector("[id='" + id + "']").offsetTop - 100,
    left: 0,
    behavior: "smooth",
  });
}

function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}
